export const FiltersEnum = {
  ACTIVE: 0,
  IN_PROGRESS: 1,
  FINISHED: 2
};
